export default "__VITE_ASSET__DG4eQZQN__"